import request from "../utils/request";

// cashCounter/queryList
export function queryList(data) {
  return request({
    url: '/cashCounter/queryList',
    method: 'post',
    data: data
  })
}
